module.exports = __webpack_public_path__ + "media/swing.7b2bae27.mp3";